export const faqs = [
  {
    question: "How far in advance should I place my order?",
    answer:
      "We recommend placing orders at least 2–3 weeks in advance for standard custom cakes, and 4–6 weeks in advance for wedding or highly detailed designs. During peak seasons such as December, New Year, and Valentine’s Day, early booking is highly recommended. Last-minute orders may be accepted based on availability."
  },
  {
    question: "Do you offer delivery services?",
    answer:
      "Yes, we offer limited delivery within Paranthan and selected areas of Kilinochchi. Delivery availability depends on distance, order size, and schedule. Customers outside our delivery zone are welcome to arrange self-pickup. Please contact us in advance to confirm delivery options."
  },
  {
    question: "Do you offer eggless or special dietary cakes?",
    answer:
      "Yes, we offer eggless cakes and can accommodate certain dietary requirements such as dairy-free or nut-free options upon request. Please inform us of any special requirements when placing your order so we can ensure quality and safety."
  },
  {
    question: "How should I store my cake before the event?",
    answer:
      "To keep your cake fresh, store it in the refrigerator and bring it to room temperature 1–2 hours before serving. Buttercream cakes should be refrigerated, while fondant cakes should be kept in a cool, dry place away from heat and direct sunlight. Storage instructions will be provided based on your cake type."
  }
];
